<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
// Chart dashboards read best centered in a narrow column; the wide data-table pages
// (Scheduled Reports, AI Handoffs) should use the full content width instead.
const isWide = computed(() =>
  ['report_schedules', 'ai_handoffs_reports', 'tickets_reports'].includes(route.name)
);
</script>

<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-6">
    <div :class="isWide ? 'w-full pb-12' : 'max-w-5xl mx-auto pb-12'">
      <router-view />
    </div>
  </div>
</template>
